import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  scrollBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  tableContainer: {
    flex: '1 1 auto',
    margin: `${theme.spacing(3)} 0 0`,
    padding: `0 0 ${theme.spacing(3)}`,
    overflowY: 'hidden',
    height: '400px'
  },
  actionRow: {
    display: 'flex',
  },
  confirm: {
    margin: '0 0 0 12px',
  },
  button: {
    padding: '0.3rem 1rem',
    fontSize: '12px',
  },
}));

export default useStyles;
